import { render, staticRenderFns } from "./FlaggedUsersViewResolver.vue?vue&type=template&id=6a698112&"
import script from "./FlaggedUsersViewResolver.vue?vue&type=script&lang=js&"
export * from "./FlaggedUsersViewResolver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports